import { useQuery } from "@tanstack/react-query";

import useBillingContext from "@app/analytics/hooks/billing/useBillingContext";
import apiClient from "@app/common/api/apiClient";
import { Invoice } from "@app/common/types";

const EMPTY_INVOICES: Invoice[] = [];

const useBillingHistory = () => {
  const { billingAccount } = useBillingContext();

  const { data, isLoading, isError } = useQuery({
    queryKey: ["billing", "invoices", billingAccount?.id],
    queryFn: () => {
      if (!billingAccount?.id) throw new Error("No billing account");
      return apiClient.billing.getBillingHistory(billingAccount.id);
    },
    enabled: Boolean(billingAccount?.id),
    staleTime: 30 * 60 * 1000,
  });

  return {
    invoices: data ?? EMPTY_INVOICES,
    isLoading,
    isError,
  };
};

export default useBillingHistory;
